import { isPlatformBrowser } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  Inject,
  Input,
  PLATFORM_ID,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MapService } from "@app/services/map.service";

@Component({
  selector: "details-map",
  templateUrl: "./map.component.html",
  standalone: false,
  styleUrl: "./map.component.scss",
})
export class DetailsMapComponent implements AfterViewInit {
  constructor(
    @Inject(PLATFORM_ID) protected platformId: Object,
    protected mapService: MapService,
    protected cdr: ChangeDetectorRef,
    protected destroyRef: DestroyRef,
  ) {}

  @Input() hotel;
  @Input() mode?: string;
  map = null;

  ngAfterViewInit() {
    try {
      if (isPlatformBrowser(this.platformId)) {
        this.mapService.Leaflet$.pipe(
          takeUntilDestroyed(this.destroyRef),
        ).subscribe((Leaflet) => {
          if (Leaflet) {
            this.onMapReady();
          }
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  onMapReady() {
    try {
      if (isPlatformBrowser(this.platformId)) {
        this.map = this.mapService.Leaflet.map("map").setView(
          [this.hotel.location?.latitude, this.hotel.location?.longitude],
          15,
        );
        this.mapService.Leaflet.tileLayer(
          "https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png",
          {
            maxZoom: 19,
            attribution:
              '&copy; <a multilang href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          },
        ).addTo(this.map);
        setTimeout(() => {
          this.map.invalidateSize();
          this.initMaps();
        }, 100);
      }
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  initMaps() {
    let icon = this.mapService.Leaflet.icon({
      iconUrl: "../../../../../assets/icons/Subtract.png",
      iconSize: [30, 40],
      iconAnchor: [15, 40],
    });
    try {
      this.mapService.Leaflet.marker(
        [
          Number(this.hotel.location?.latitude),
          Number(this.hotel.location?.longitude),
        ],
        {
          icon: icon,
        },
      )
        .bindPopup(this.hotel.popup)
        .addTo(this.map);
      this.map?.invalidateSize();
      this.cdr.detectChanges();
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }
}
